import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import ReactPaginate from "react-paginate";

const Clientlist = () => {
    
    const [clients, setClient] = useState([]);
    const [page, setPage] = useState(0);
    const [limit] = useState(10);
    const [pages, setPages] = useState(0);
    const [rows, setRows] = useState(0);
    const [keyword, setKeyword] = useState("");
    const [query, setQuery] = useState("");
    const [msg, setMsg] = useState("");
    // Access the environment variables
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const API_KEY = process.env.REACT_APP_API_KEY;

    useEffect(() => {
        getClient();
    }, [page, keyword]);

    const getClient = async () => {
        const response = await axios.get(
            `${API_BASE_URL}/clients?search_query=${keyword}&page=${page}&limit=${limit}`,
            {
                headers: {
                    'X-API-Key': API_KEY
                },
            }
        );
        setClient(response.data.result);
        setPage(response.data.page);
        setPages(response.data.totalPage);
        setRows(response.data.totalRows);
    };

    const changePage = ({ selected }) => {
        setPage(selected);
        if (selected === 9) {
        setMsg(
            "Jika tidak menemukan data yang Anda cari, silahkan cari data dengan kata kunci spesifik!"
        );
        } else {
        setMsg("");
        }
    };

    const searchData = (e) => {
        e.preventDefault();
        setPage(0);
        setMsg("");
        setKeyword(query);
    };

    const deleteClient = async (clientId) => {
        if (window.confirm('Are you sure you want to delete this item?')) {
            await axios.delete(`${API_BASE_URL}/clients/${clientId}`);
            getClient();
        } else {
            return
        }   
    };

    return (
        <div className="container">
        <div className="columns">
            <div className="column is-centered">
            <h1 className="title is-size-5">Data Client/Customer</h1>
            <div className="columns">
                <div className="column is-2">
                <Link to="/clients/add" className="button is-small is-primary">
                    Add New Customer
                </Link>
                </div>
                <div className="column is-6">
                <form onSubmit={searchData}>
                    <div className="field has-addons">
                    <div className="control is-expanded">
                        <input
                        type="text"
                        className="input is-small"
                        value={query}
                        onChange={(e) => setQuery(e.target.value)}
                        placeholder="Search by client name..." />
                    </div>
                    <div className="control">
                        <button type="submit" className="button is-small is-info">
                        Search
                        </button>
                    </div>
                    </div>
                </form>
                </div>
            </div>
            <table className="table is-striped is-fullwidth is-size-7">
                <thead>
                <tr>
                    <th>No</th>
                    <th className="has-text-centered">Actions</th>
                    <th>Name</th>
                    <th>Address</th>
                    <th>Email</th>
                    <th>Phone</th>
                    <th>VAT</th>                    
                </tr>
                </thead>
                <tbody>
                {clients.map((client, index) => (
                    <tr key={client.uuid}>
                    <td>{index + 1}</td>
                    <td className="has-text-centered">
                        <div className="is-inline-flex">
                        <Link
                            to={`/clients/edit/${client.uuid}`}
                            className="button is-small is-info mr-1"
                        >
                            Edit
                        </Link>
                        <button
                            onClick={() => deleteClient(client.uuid)}
                            className="button is-small is-danger"
                        >
                            Delete
                        </button>
                        </div>
                    </td>
                    <td>{client.name}</td>
                    <td>{client.address}</td>
                    <td>{client.email}</td>
                    <td>{client.phone}</td>
                    <td>{client.vat}</td>
                    
                    </tr>
                ))}
                </tbody>
            </table>
            <p className="is-size-7">
                Total Record: {rows} Page: {rows ? page + 1 : 0} of {pages}
            </p>
            <p className="has-text-centered has-text-danger">{msg}</p>
            <nav
                className="pagination is-centered is-size-7"
                key={rows}
                role="navigation"
                aria-label="pagination"
            >
                <ReactPaginate
                breakLabel="..."
                previousLabel={"< Prev"}
                nextLabel={"Next >"}
                pageCount={Math.min(10, pages)}
                onPageChange={changePage}
                containerClassName={"pagination-list"}
                pageLinkClassName={"pagination-link"}
                previousLinkClassName={"pagination-previous"}
                nextLinkClassName={"pagination-next"}
                activeLinkClassName={"pagination-link is-current"}
                disabledLinkClassName={"pagination-link is-disabled"} />
            </nav>
            </div>
        </div>
        </div>
    );
};

export default Clientlist;
